document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.faq-question').forEach((button) => {
      button.addEventListener('click', function () {
          const content = this.parentElement;
          const isActive = content.classList.toggle('active');

          document.querySelectorAll('.faq-content').forEach((item) => {
              if (item !== content) item.classList.remove('active');
          });

          this.setAttribute('aria-expanded', isActive);
          this.querySelector('.faq-icon-up').classList.toggle('hidden', !isActive);
          this.querySelector('.faq-icon-down').classList.toggle('hidden', isActive);
      });
  });
});
